import { AGENCY_INCLUDED_SEATS } from "features/subscriptions/constants";
import { useManageSubscription } from "features/subscriptions/context/ManageSubscriptionContext";
import useMinSeatQuantity from "features/subscriptions/hooks/useMinSeatQuantity";

import { CountSpinner } from "common/components/ui/CountSpinner";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function QuantitySelection() {
  const isDesktop = useTwBreakpoint("lg");

  const {
    subscriptionType,
    seatQuantity,
    setSeatQuantity,
    hasActiveSubscription,
    rentalOrderSubscription,
    pricing,
  } = useManageSubscription();

  const { minSeatQuantity, isAgencyPurchase, totalActiveOutreachSeats } =
    useMinSeatQuantity(subscriptionType, hasActiveSubscription, pricing?.plan);

  let minValueTooltipText =
    subscriptionType === "rental"
      ? "Subscription is currently at the minimum number of Avatars"
      : "Subscription is currently at the minimum number of seats";

  if (isAgencyPurchase && totalActiveOutreachSeats > AGENCY_INCLUDED_SEATS) {
    minValueTooltipText =
      "Minimum seats must cover your active Outreach subscriptions";
  }
  return (
    <CountSpinner
      variant={isDesktop ? "sm" : "lg"}
      inputId="seats-spinner"
      value={seatQuantity}
      setValue={setSeatQuantity}
      maxValue={
        rentalOrderSubscription ? rentalOrderSubscription.rented_count : 999
      }
      minValue={minSeatQuantity}
      minValueTooltipText={minValueTooltipText}
      maxValueTooltipText={
        rentalOrderSubscription
          ? "Because of delivery times and the customization process, we cannot add new Avatars to an existing order. If you want to get more avatars, please place another order."
          : undefined
      }
    />
  );
}
